import { useState } from 'react';
import { Settings, Mail } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from './ui/dialog';
import { toast } from 'sonner';
import { useI18n } from '../lib/i18n';
import { createCustomerPortal } from '../lib/api';

const PortalDialog = ({ trigger }) => {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      setLoading(true);
      const { url } = await createCustomerPortal(email, window.location.origin);
      window.location.href = url;
    } catch (err) {
      const detail = err?.response?.data?.detail || t.portal.notFound;
      toast.error(detail);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent
        data-testid="portal-dialog"
        className="rounded-[2rem] border border-black/10 p-8 max-w-md"
      >
        <DialogHeader>
          <div className="mx-auto w-14 h-14 rounded-full bg-[#0071E3]/10 flex items-center justify-center mb-4">
            <Settings className="w-6 h-6 text-[#0071E3]" />
          </div>
          <DialogTitle className="text-center text-2xl font-bold tracking-tight text-[#1D1D1F]">
            {t.portal.title}
          </DialogTitle>
          <DialogDescription className="text-center text-[#86868B] text-[15px] leading-relaxed">
            {t.portal.desc}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="mt-4 space-y-4">
          <div>
            <label className="block text-xs font-semibold tracking-wider uppercase text-[#86868B] mb-2">
              <Mail className="inline w-3 h-3 mr-1 -mt-0.5" /> {t.portal.emailLabel}
            </label>
            <input
              data-testid="portal-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-[#F5F5F7] border-2 border-transparent focus:bg-white focus:border-[#0071E3] focus:ring-4 focus:ring-[#0071E3]/10 rounded-2xl px-5 py-4 text-[15px] text-[#1D1D1F] placeholder:text-[#86868B] transition-all outline-none"
              placeholder="info@premiumlaundryservices.org"
            />
          </div>
          <div className="flex gap-3 justify-center pt-2">
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="bg-[#F5F5F7] hover:bg-[#E8E8ED] text-[#1D1D1F] font-semibold rounded-full px-6 py-3 transition-transform hover:scale-[1.02] active:scale-95"
            >
              {t.portal.cancel}
            </button>
            <button
              data-testid="portal-open-btn"
              type="submit"
              disabled={loading}
              className="bg-[#0071E3] hover:bg-[#0077ED] disabled:opacity-60 text-white font-semibold rounded-full px-6 py-3 transition-transform hover:scale-[1.02] active:scale-95"
            >
              {loading ? t.portal.opening : t.portal.open}
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default PortalDialog;
